/* eslint-disable camelcase */
import React from 'react';

const searchBoxStyle = {
  width: '418px',
  margin: '36px',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  padding: '8px',
  overflow: 'hidden',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '19px',
  backgroundColor: '#fff',
  bordeRadius: '4px',
  boxShadow: '0 1px 4px -1px rgba(0, 0, 0, 0.3)',
};

const MapViewSearchBox: React.FC = () => (
  <input
    style={searchBoxStyle}
    id="map-search-address"
    data-testid="input-field-map-search-address"
    className="controls"
    type="text"
    onKeyPress={(e) => e.key === 'Enter' && e.preventDefault()}
    placeholder="Search address"
  />
);
export default MapViewSearchBox;
